import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu,{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn,_vm._g(_vm._b({attrs:{"color":"primary","icon":"","dark":""},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}},'v-btn',attrs,false),on),[_c('country-flag',{attrs:{"country":_vm.currentLanguage}})],1)]}}])},[_c(VList,_vm._l((_vm.langs),function(item,index){return _c(VListItem,{key:index,on:{"click":function($event){return _vm.changeLanguage(item.type)}}},[_c(VListItemTitle,[_vm._v(_vm._s(item.type))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }